// NOTE this file contains the internal dependencies of @lvflanders BAR modules
// we use this to avoid having to break whenever a new version is used
// UMD bundles from ngx-packagr through Angular Libraries doesn't bundle this code (because not possible or too difficult)
import * as idb from "idb";
import * as postscribe from "postscribe";
import * as signalr from "@microsoft/signalr";
import { lit, litNamespaces } from "./lit.generated";
import axios from "axios";
import * as inversify from "inversify";
import * as reflectMetadata from "reflect-metadata";
import * as fileSaver from "file-saver";
import * as oidcClientTs from "oidc-client-ts";
import * as elasticApmRumCore from "@elastic/apm-rum-core";
import * as elasticApmRum from "@elastic/apm-rum";

const litDecorators = litNamespaces["lit/decorators.js"];

// global glue variable for externals
window["idb"] = idb;
window["postscribe"] = postscribe;
window["microsoft"] = { signalr };
window["lit"] = lit;
window["axios"] = axios;
window["inversify"] = inversify;
window["reflect-metadata"] = reflectMetadata;
window["file-saver"] = fileSaver;
window["oidc-client-ts"] = oidcClientTs;
window["@elastic"] = {
  "apm-rum-core": elasticApmRumCore,
  "apm-rum": elasticApmRum,
};

export {
  idb,
  postscribe,
  signalr,
  lit,
  litDecorators,
  litNamespaces,
  axios,
  inversify,
  reflectMetadata,
  fileSaver,
  oidcClientTs,
  elasticApmRumCore,
  elasticApmRum,
};
